import { LOCAL_STORAGE_KEY, DISMISS_DURATION_MS } from "./constants";

const setDismissed = () => {
  try {
    localStorage.setItem(
      LOCAL_STORAGE_KEY,
      String(Date.now() + DISMISS_DURATION_MS)
    );
  } catch (_) {
    // localStorage unavailable — silently ignore
  }
};

export default setDismissed;
